// Fictieve demo-data voor de Ghost Driver web-schermen (0 echte data).
// Velden volgen het Property-schema uit het API-contract (fictieve woningen, Gent).
export const PROPS = {
  demo_p1: {
    id: 'demo_p1', title: 'Karakterhuis · Stationsstraat 14', city: 'Gent', region: 'Oost-Vlaanderen',
    price: '€ 320.000', priceDropped: '€ 305.000', beds: 3, epc: 'B', surface: 148,
    tags: ['tuin', 'station 4 min'], match: 92,
    img: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=800&auto=format&fit=crop',
    why: 'Rustige zijstraat · station 4 min · past bij jouw voorkeuren',
    match_reasons: ['Rustige zijstraat', 'Tuin aanwezig', 'Station 4 min'],
    agent_name: 'Makelaarskantoor Gent', agent_phone: '+32 9 123 45 67',
    agent_email: 'info@makelaarskantoor-gent.be', address: 'Stationsstraat 14, 9000 Gent',
  },
  demo_p2: {
    id: 'demo_p2', title: 'Karakterhuis · Wondelgem', city: 'Gent', region: 'Oost-Vlaanderen',
    price: '€ 385.000', beds: 3, epc: 'B', surface: 156,
    tags: ['tuin > 100 m²', 'station 8 min'], match: 94,
    img: 'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=800&auto=format&fit=crop',
    why: 'Station 8 min · tuin > 100 m² · 94% overlap Tom & Emma',
    match_reasons: ['Tuin > 100 m²', 'Station 8 min', 'EPC B'],
    agent_name: 'Makelaarskantoor Gent', agent_phone: '+32 9 123 45 67',
    agent_email: 'info@makelaarskantoor-gent.be', address: 'Wondelgemstraat 88, 9032 Gent',
  },
  demo_p3: {
    id: 'demo_p3', title: 'Appartement · Gent Zuid', city: 'Gent', region: 'Oost-Vlaanderen',
    price: '€ 289.000', beds: 2, epc: 'A', surface: 89,
    tags: ['geen buitenruimte'], match: 64,
    img: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&auto=format&fit=crop',
    why: 'Geen terras of tuin — zwakkere match',
    match_reasons: ['Lichtrijk', 'Centrum dichtbij'],
    agent_name: 'Makelaarskantoor Gent', agent_phone: '+32 9 123 45 67',
    agent_email: 'info@makelaarskantoor-gent.be', address: 'Zuidstationstraat 22, 9000 Gent',
  },
  demo_p4: {
    id: 'demo_p4', title: 'Rijwoning · Sint-Amandsberg', city: 'Gent', region: 'Oost-Vlaanderen',
    price: '€ 349.000', beds: 3, epc: 'C', surface: 132,
    tags: ['tuin', 'terras'], match: 81,
    img: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800&auto=format&fit=crop',
    why: 'Tuin + terras · iets verder van het station',
    match_reasons: ['Tuin + terras', 'Ruime indeling'],
    agent_name: 'Makelaarskantoor Gent', agent_phone: '+32 9 123 45 67',
    agent_email: 'info@makelaarskantoor-gent.be', address: 'Dendermondsesteenweg 145, 9040 Gent',
  },
  demo_p5: {
    id: 'demo_p5', title: 'Nieuwbouw-appartement · Gentbrugge', city: 'Gent', region: 'Oost-Vlaanderen',
    price: '€ 319.000', beds: 2, epc: 'A', surface: 96,
    tags: ['terras', 'nieuwbouw'], match: 58,
    img: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800&auto=format&fit=crop',
    why: 'Nieuwbouw zonder tuin — past minder bij Tom',
    match_reasons: ['Nieuwbouw', 'Terras'],
    agent_name: 'Makelaarskantoor Gent', agent_phone: '+32 9 123 45 67',
    agent_email: 'info@makelaarskantoor-gent.be', address: 'Brusselsesteenweg 301, 9050 Gent',
  },
};

// Swipe-decks: solo (Sofie) en couple (Tom → Emma → Tom)
export const DECKS = {
  solo: ['demo_p1', 'demo_p3', 'demo_p4'],
  couple: ['demo_p2', 'demo_p2', 'demo_p5'],
};

export const NOTIFS = {
  solo: [
    { icon: 'heart', accent: '#c48a3a', title: '🎯 Nieuwe TopMatch 92%', body: 'Stationsstraat 14 past uitzonderlijk bij jouw profiel.', time: 'Nu' },
    { icon: 'trending-down', accent: '#c48a3a', title: '📉 Prijsdaling —€15.000', body: 'Stationsstraat 14 zakte naar €305.000 — nu binnen budget.', time: '2u' },
    { icon: 'calendar', accent: '#1B3A5C', title: '📅 Bezoekdag beschikbaar', body: 'Za 14:00 · plaats bij makelaar. Deelnemen?', time: '5u' },
    { icon: 'check-circle', accent: '#22C55E', title: '📆 Bezoek bevestigd — Za 14:00', body: 'Zie je daar! Agenda-uitnodiging staat klaar.', time: '1d' },
  ],
  couple: [
    { icon: 'heart', accent: '#e0559c', title: '💛 Koppelmatch — Wondelgem', body: 'Jullie vinden allebei deze woning leuk.', time: 'Nu' },
    { icon: 'check-circle', accent: '#22C55E', title: '📆 Bezoek bevestigd — Do 10:00', body: 'Zichtbaar bij Tom én Emma. Agenda-invite verstuurd.', time: '1u' },
    { icon: 'trending-up', accent: '#c48a3a', title: '💰 Gezamenlijk budget €385.000', body: 'Jullie budgetten liggen binnen dezelfde zoekzone.', time: '3u' },
    { icon: 'user', accent: '#c48a3a', title: '👥 Tom vond een woning leuk', body: 'Wondelgem — bekijk om samen te matchen.', time: '1d' },
  ],
};

export const MARKTPULSE = [
  { tag: 'PRIJZEN', title: 'Gent-centrum: € 3.240/m²', body: 'Gemiddelde prijs stabiel deze maand.' },
  { tag: 'AANBOD', title: 'Aanbod karakterhuizen +6%', body: 'Meer woningen met tuin in de budgetzone.' },
  { tag: 'RENTE', title: 'Rentevoet licht gedaald', body: 'Invloed op je maandlast: −€ 18/maand.' },
];

// Ontdek-feed (fictief) — topmatch van de week + highlights + kansen.
export const FEED = {
  solo: {
    firstName: 'Sofie', coupleName: null, isCouple: false,
    topmatch: 'demo_p1',
    highlights: ['demo_p1', 'demo_p4', 'demo_p3', 'demo_p2'],
    kansen: [{ id: 'demo_p1', drop_pct: 5 }],
  },
  couple: {
    firstName: 'Tom', coupleName: 'Tom & Emma', isCouple: true,
    topmatch: 'demo_p2',
    highlights: ['demo_p2', 'demo_p1', 'demo_p4'],
    kansen: [],
  },
};

// ── Bezoeken-demo-state per scriptstap (Ghost Driver stuurt de fase aan) ──
function nextDow(dow) {
  const d = new Date();
  const diff = ((dow - d.getDay()) + 7) % 7 || 7;
  const r = new Date(d);
  r.setDate(d.getDate() + diff);
  return r;
}

export function demoBezoekenState(mode, stepId) {
  const isCouple = mode === 'couple';
  const property_id = isCouple ? 'demo_p2' : 'demo_p1';
  // Solo: stap 20-22 = aangevraagd, stap 23+ = bevestigd. Koppel: stap 20+ = bevestigd.
  const inFlow = stepId >= 20;
  const confirmed = isCouple ? stepId >= 20 : stepId >= 23;
  const when = nextDow(isCouple ? 4 : 6); // koppel: donderdag 10:00 · solo: zaterdag 14:00
  const whenLabel = `${when.toLocaleDateString('nl-BE', { weekday: 'long', day: '2-digit', month: 'long' })} om ${isCouple ? '10:00' : '14:00'}`;
  return {
    view: inFlow ? 'alle' : 'hub',
    whenLabel,
    maybeCount: isCouple ? 0 : 1,
    counts: {
      nog_in_te_plannen: isCouple ? 0 : 1,
      gepland: 1,
      alle: isCouple ? 1 : 2,
    },
    visit: {
      id: 'demo-visit-1',
      property_id,
      is_couple: isCouple,
      status: confirmed ? 'ingepland' : 'aangevraagd',
      agent_confirmed: confirmed,
    },
  };
}
